<template lang="html">
  <div class="indicator-wrapper">
    <div class="indicator-container">
      <div class="value">
        <v-progress-circular
          v-if="loading"
          :size="30"
          color="primary"
          indeterminate
        />
        <v-icon color="red" v-else-if="error">fa-exclamation-circle</v-icon>
        <div v-else :style="valueStyle">{{loading ? '' : value}}</div>
      </div>
      <div class="label">
        {{label}}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.indicator-wrapper {
  text-align: center;
  border-radius: 0.5em;
  padding: 0.2em 0.4em;
  .indicator-container {
    background-color: #fff;
    padding: 1em;
    .value {
      font-size: 3em;
      height: 1.4em;
      justify-content: center;
      align-items: center;
      display: flex;
    }
    .label {
      font-size: 1.2em;
      color: #999;
    }
  }
}
</style>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      default: null
    },
    value: {
      type: [Number, String],
      default: '-'
    },
    label: {
      type: String,
      default: '-'
    },
    lengthy: {
      type: Boolean,
      default: false
    },
    shrinkIfLong: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    valueStyle () {
      if (this.shrinkIfLong) {
        if (this.value && (this.value + '').length > 8) {
          return { fontSize: '0.8em', lineHeight: '1.3em' }
        } else if (this.value && (this.value + '').length > 12) {
          return { fontSize: '0.5em', lineHeight: '1.3em' }
        }
      } else if (this.lengthy) {
        return { fontSize: '0.5em', lineHeight: '1.3em' }
      }
      return {}
    }
  }
}
</script>
